import { namespace } from "vuex-class";
import { Component, Vue } from "vue-property-decorator";
import { StoreModule } from "@/store/types";
import {
  SurchargeActions,
  SurchargeGetters
} from "@/store/modules/surcharge/types";
import { SurchargeRate } from "@/store/modules/surcharge/types";
import { SurchargeInfo } from "@/models/pricing/price";

/** FUMBSD-761: the API's surcharge (GET /prices/surcharge), same as Shade Designer */
@Component
export class SurchargeStore extends Vue {
  @(namespace(StoreModule.Surcharge).Action(SurchargeActions.Refresh))
  refreshSurcharge!: (force?: boolean) => Promise<void>;
  @(namespace(StoreModule.Surcharge).Action(SurchargeActions.Seed))
  seedSurcharge!: (surcharge: SurchargeRate) => Promise<void>;
  @(namespace(StoreModule.Surcharge).Getter(SurchargeGetters.GetSurcharge))
  surcharge!: SurchargeInfo;
  @(namespace(StoreModule.Surcharge).Getter(
    SurchargeGetters.GetSurchargeIsActive
  ))
  surchargeIsActive!: boolean;
}
